"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  var placeholder = {
    fontStyle: 'italic',
    color: theme['$placeholder-color']
  };
  return {
    Input: {
      isolate: true,
      '&, &[type], &[disabled], &[readonly], &[type][disabled], &[type][readonly]': {
        boxSizing: 'border-box',
        border: 'none',
        outline: 'none',
        padding: {
          top: 9,
          bottom: 9,
          left: 12,
          right: 12
        },
        borderRadius: 6,
        fontFamily: theme['$font-default'],
        fontSize: 12,
        lineHeight: 'initial',
        background: theme['$input-background'],
        color: theme['$text-color'],
        '&:focus': {
          background: theme['$input-background-focus']
        },
        '&::placeholder': placeholder,
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        '&:placeholder': placeholder,
        '&:-ms-input-placeholder': placeholder,
        '&:-moz-placeholder': placeholder,
        // override styles from EV
        width: 'initial',
        fallbacks: {
          height: 'auto' // IE11 does not know of "initial" so need to use "auto" here

        },
        height: 'initial',
        boxShadow: 'none',
        transition: 'none',
        margin: 0,
        verticalAlign: 'middle',
        fontWeight: 'normal'
      }
    },
    Light: {
      '&, &[type], &[readonly], &[type][readonly]': {
        backgroundColor: theme['$input-background-light']
      }
    },
    Disabled: {
      '&, &[type], &[readonly], &[type][readonly], &[disabled][readonly], &[type][disabled][readonly]': {
        opacity: 0.3
      }
    },
    Error: {
      '&, &[type], &[readonly], &[type][readonly], &[disabled][readonly], &[type][disabled][readonly]': {
        background: theme['$input-background-error']
      }
    },
    Warning: {
      '&, &[type], &[readonly], &[type][readonly], &[disabled][readonly], &[type][disabled][readonly]': {
        background: theme['$input-background-warning']
      }
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map